import { BenefitsList } from './benefits-list'

export { BenefitsList }
